export const isGatsbyImageData = (imageData) => {
  return !!imageData && typeof imageData === 'object' && (!!imageData.images || !!imageData.layout);
};

// Returns width/height. Suitable for flex sizing where larger values grow more horizontally.
export const getAspectRatio = (imageData) => {
  if (!imageData) return 1;
  if (typeof imageData.aspectRatio === 'number') return imageData.aspectRatio; // legacy fluid aspectRatio = width/height
  if (typeof imageData.width === 'number' && typeof imageData.height === 'number' && imageData.height > 0) {
    return imageData.width / imageData.height; // gatsbyImageData provides width & height
  }
  return 1;
};

// Returns height/width. Suitable for padding-bottom % to preserve aspect ratio.
export const getPaddingBottomRatio = (imageData, proportionOverride) => {
  if (typeof proportionOverride === 'number') return proportionOverride;
  if (!imageData) return undefined;
  if (typeof imageData.aspectRatio === 'number' && imageData.aspectRatio > 0) {
    return 1 / imageData.aspectRatio; // invert legacy fluid aspectRatio
  }
  if (typeof imageData.width === 'number' && typeof imageData.height === 'number' && imageData.width > 0) {
    return imageData.height / imageData.width; // derive from gatsbyImageData
  }
  return undefined;
};


